module.exports = {"template":"template_for_angular.html"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/template_for_angular/setting.json
// module id = 515
// module chunks = 0 1 2 3 4 5